import styled from 'styled-components';

export const Separator = styled.div<{ hasBorder?: boolean }>`
  border-bottom: ${({ theme }) => theme.space['0.1']} solid ${({ theme }) => theme.colors.capsuleGray10};
  border-bottom: ${({ hasBorder }) => !hasBorder && 'none'};
  padding-top: ${({ theme }) => theme.space.s5};
  margin-bottom: ${({ theme }) => theme.space.s5};
`;

export const Container = styled.div`
  margin-bottom: ${({ theme }) => theme.space.s5};
`;

/**
 * Since the fields above are dynamically generated and animated, we can't use pseudoselectors or even props to
 * detect if it's the last field because the margins would jolt.
 *
 * If there's a SINGLE field above the button (just medication for non-experiment users), we want a little less.
 */
export const ButtonContainer = styled.div<{ hasOneFieldSet: boolean }>`
  margin-top: ${({ hasOneFieldSet, theme }) => (!hasOneFieldSet ? `-${theme.space.s5}` : `-${theme.space.s3}`)};
`;

export const Combobox = styled.div`
  position: relative;
  color: ${({ theme }) => theme.colors.capsuleBlue50};
`;

export const Menu = styled.ul`
  list-style-type: none;
  background: ${props => props.theme.colors.white};
  box-shadow: ${props => props.theme.shadows.dp2};
  max-height: 300px;
  overflow-y: scroll;
  position: absolute;
  width: 100%;
  z-index: ${props => props.theme.zIndices.overlayEverything};
  &:hover {
    cursor: pointer;
  }
  li {
    &:not(:last-of-type) {
      border-bottom: 1px solid ${props => props.theme.colors.capsuleGreen10};
    }
  }
`;

export const Item = styled.li`
  padding: ${({ theme }) => `${theme.space.s5} ${theme.space.s4}`};

  background-color: ${props => props.theme.colors.white};

  &:hover,
  &[aria-selected='true'] {
    background-color: ${props => props.theme.colors.capsuleGreen00};
    color: ${props => props.theme.colors.capsuleGreen60};
  }

  &:active {
    background-color: ${props => props.theme.colors.capsuleGreen60};
    color: ${props => props.theme.colors.white};
  }
`;

export const DropdownHeader = styled.li`
  padding: ${props => props.theme.space.s4};
  cursor: default;
`;
